import React from 'react';
var defaultParams = {
  toasts: [],
  toastHovering: false,
  updateToasts: function updateToasts(t) {
    return t;
  },
  updateToastHoverStatus: function updateToastHoverStatus() {}
};
export var GeistUIContent =
/*#__PURE__*/
React.createContext(defaultParams);
export var useGeistUIContext = function useGeistUIContext() {
  return React.useContext(GeistUIContent);
};